import { render, staticRenderFns } from "./mainMenuItem.vue?vue&type=template&id=47e8b7a6&"
import script from "./mainMenuItem.vue?vue&type=script&lang=js&"
export * from "./mainMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports